// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"LoadProject_dropzone__FK8Ov","reject":"LoadProject_reject__2koRP","accept":"LoadProject_accept__3iKiQ","browse-button":"LoadProject_browse-button__3Q8eV"};